<template>
    <v-dialog v-model="OpenDialogshowLogs" persistent max-width="700" :scrollable="true">
        <v-card style="height: 80vh;">
            <v-card-title>
                <v-row>
                    <v-col cols="10">
                        <template>
                            <div class="d-flex align-center">
                                <v-icon size="36" color="#0070C0" aria-label="Seguimiento">
                                    mdi-clipboard-text
                                </v-icon>
                                <span class="ml-3 font-weight-medium">Seguimiento</span>
                            </div>
                        </template>
                    </v-col>
                    <v-col cols="2" style="text-align: end; cursor: pointer;" @click="closeModal">
                        <v-icon left color="#858C94">
                            mdi-close
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text style="height: 400px;">
                <v-container>
                    <v-expansion-panels class="pb-5" v-for="(log, idx) in logs" :key="idx">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <v-row>
                                    <v-col cols="12" style="align-self: center;">
                                        <h4>Estatus {{ log.status }}</h4>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div v-html="log.cuerpo"></div>
                                <v-row>
                                    <v-col cols="12">
                                        <h4>Fecha {{ log.fechaCambio }}</h4>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content>
                                <v-row class="pt-4">
                                    <v-col cols="12">
                                        <h4>Modificado por: {{ log.nombreModificador }}</h4>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-card-text>
            <v-card-actions style="justify-content: center;">
                <div style="display: flex; justify-content: center; align-items: center;">
                    <v-pagination v-model="page" :length="pages" circle color="#0070C0"></v-pagination>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment";

export default {
    components: {},
    props: {
        OpenDialogshowLogs: {
            type: Boolean,
            default: false,
        },
        logs: Array,
        correosSegurify: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            requiredRule: [(v) => !!v || "El campo es requerido"],
            data: {
                nombre: null,
                enviarPorCorreo: false,
                nota: null,
                tipo: "Nota",
                tipo_documento: null,
            },
            run: false,
            formData: null,
            page: 1,
            limit: 5,
            filtro: null,
        };
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
        openCreateModal() {
            this.$emit("openCreateModal");
        },
        getFormatDate(date) {
            return moment(date)
                .subtract(6, "hours")
                .format("DD/MM/YYYY");
        },
    },
    computed: {
        pages() {
            if (!this.emailsFiltrados) return 1;
            const totalPages = Math.ceil(this.emailsFiltrados.length / this.limit);
            return totalPages < 1 ? 1 : totalPages;
        },
        emailsFiltrados() {
            if (!this.filtro) {
                return this.correosSegurify;
            }
            const filtroMin = this.filtro.toLowerCase().trim();
            return this.correosSegurify.filter((nota) => {
                return nota.nota.toLowerCase().includes(filtroMin);
            });
        },
        indiceInicio() {
            return (this.page - 1) * this.limit;
        },
        indiceFinal() {
            return this.page * this.limit - 1;
        },
        showNotes() {
            return this.emailsFiltrados.slice(
                this.indiceInicio,
                this.indiceFinal + 1
            );
        },
    },
};
</script>

<style scoped>
.custom-list {
    background-color: #0058fc;
    border-radius: 10px;
    text-align: center;
    margin: 5px 0px 5px 0px;
}

.v-expansion-panel {
    background-color: rgb(165, 55, 238);
}

.v-expansion-panels {
    z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active {
    border-radius: 5px !important;
    background-color: aliceblue;
}

.v-expansion-panel-header {
    background-color: aliceblue;
    border-radius: 5px;
}
</style>
